import 'styles/watermark.css';

function Watermark(props: { text: string }) {
  return <div id="watermark">{props.text}</div>;
}

export default Watermark;
